import React from "react";
import { motion } from "framer-motion";
import SettingsIcon from "@mui/icons-material/Settings";
import UberDirectConfigForm from "./UberDirectConfigForm";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../../../modals/AnimatedModal";
import UberService from "../../../../api/uber";

// Modal animation variants
const modalContentVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.2, duration: 0.4 },
  },
};

const UberDirectConfigModal = ({ open, onClose, existingCredentials }) => {
  const handleSubmit = async (formData) => {
    try {
      if (existingCredentials) {
        return await UberService.editCredentials(
          existingCredentials.id,
          formData
        );
      }

      return await UberService.createCredentials(formData);
    } catch (error) {
      console.error("Error saving Uber Direct credentials:", error);
      throw error;
    }
  };

  return (
    <AnimatedModal isOpen={open} onClose={onClose} width="500px">
      <ModalHeader
        title="Configuração Uber Direct"
        icon={SettingsIcon}
        onClose={onClose}
      />
      <ModalContent>
        <motion.div
          variants={modalContentVariants}
          initial="hidden"
          animate="visible"
        >
          <UberDirectConfigForm
            existingCredentials={existingCredentials}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        </motion.div>
      </ModalContent>
    </AnimatedModal>
  );
};

export default UberDirectConfigModal;
